import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { BusinessHoursComponent } from './crud-ces/business-hours/business-hours.component';
import { PartnerCrudIndex } from './crud-index/crud-index';
import { PartnerIndexSelectComponent } from './crud-index/crud-index-select.component';
import { PartnerCESComponent } from './crud-ces/crud-ces.component';
import { PartnerIndexComponent } from './crud-index/crud-index.component';
import { PartnerIndexMultiSelectComponent } from './crud-index/crud-index-multiselect.component';
import { PartnerContractGenerateComponent } from './components/contract-generate/contract-generate.component';
import { ContractRoleSelectionComponent } from './components/contract-role-selection/contract-role-selection.component';
import { PartnersRoutingModule } from './partners-routing.module';
import { CustomerDataDialogModule } from './customer-data-dialog/customer-data-dialog.module';
import { PartnerSettingsModule } from './crud-index/partner-settings/partner-settings.module';
import { PartnerService } from './crud-service';
import { PartnerContractService } from './services/partner-contract.service';
import { PartnerContractStatusService } from './services/partner-contract-status.service';
import { ContractTypeResolverService } from './services/contract-type-resolver.service';
import { DialogMerchantComponent } from './crud-ces/dialog-merchant/dialog-merchant.component';
import { ContractsListDialogModule } from '../contracts/components/contract-dialog/contract-list-modal/contracts-list-dialog.module';
import { UserGroupPermissionsModule } from '../user-group-permissions/user-group-permissions.module';

@NgModule({
  declarations: [
    PartnerCrudIndex,
    PartnerIndexSelectComponent,
    PartnerCESComponent,
    PartnerIndexComponent, 
    PartnerIndexMultiSelectComponent,
    BusinessHoursComponent,
    PartnerContractGenerateComponent,
    ContractRoleSelectionComponent,
    DialogMerchantComponent
  ],
  imports: [
    CommonModule,
    PartnersRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CustomerDataDialogModule,
    PartnerSettingsModule,
    ContractsListDialogModule,
    UserGroupPermissionsModule,
  ],
  providers: [
    DatePipe,
    PartnerService,
    PartnerContractService,
    PartnerContractStatusService,
    ContractTypeResolverService
  ],
  exports: [
    PartnerIndexSelectComponent,
    PartnerIndexMultiSelectComponent,
    PartnerContractGenerateComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class PartnersModule { }
